const problems = [
  {
    problem: 'Manual inventory tracking leads to stockouts',
    solution: 'Automated real-time inventory with instant low-stock alerts',
    icon: 'ri-bar-chart-box-line',
    solutionIcon: 'ri-checkbox-circle-line',
  },
  {
    problem: 'Lost customer service records',
    solution: 'Digital vehicle history by VIN or registration number',
    icon: 'ri-file-damage-line',
    solutionIcon: 'ri-checkbox-circle-line',
  },
  {
    problem: 'Time wasted answering parts availability calls',
    solution: 'Online portal with live stock and self-service ordering',
    icon: 'ri-phone-line',
    solutionIcon: 'ri-checkbox-circle-line',
  },
  {
    problem: 'Managing multiple suppliers is complex',
    solution: 'Centralized supplier dashboard with analytics & automation',
    icon: 'ri-error-warning-line',
    solutionIcon: 'ri-checkbox-circle-line',
  },
];

const ProblemSolution = () => {
  return (
    <section className="bg-[#0a1628] py-24 px-6" id="solutions">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#f97316]/10 border border-[#f97316]/25 rounded-full mb-5">
            <i className="ri-tools-line text-[#f97316] text-sm"></i>
            <span className="text-[#f97316] text-xs font-semibold tracking-widest uppercase">Real Challenges. Real Solutions.</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Built to Solve Real Automotive
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#3b82f6] to-[#f97316]">
              Business Challenges
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            We talked to hundreds of South African workshop owners and parts dealers. These are the problems they face every day — and how PRODIFY solves them.
          </p>
        </div>

        {/* Split grid */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          {/* Problems column */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center bg-red-500/15 rounded-lg">
                <i className="ri-close-circle-line text-red-400 text-lg"></i>
              </div>
              <span className="text-red-400 font-semibold text-sm uppercase tracking-wider">The Problems</span>
            </div>
            <div className="space-y-4">
              {problems.map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-4 p-5 bg-[#0f1e38] border border-red-500/15 rounded-xl group hover:border-red-500/30 transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-red-500/10 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-red-400 text-xl`}></i>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed pt-1">{item.problem}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Solutions column */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 flex items-center justify-center bg-green-500/15 rounded-lg">
                <i className="ri-checkbox-circle-line text-green-400 text-lg"></i>
              </div>
              <span className="text-green-400 font-semibold text-sm uppercase tracking-wider">PRODIFY Solutions</span>
            </div>
            <div className="space-y-4">
              {problems.map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-4 p-5 bg-[#0f2040] border border-[#3b82f6]/20 rounded-xl group hover:border-[#3b82f6]/40 transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-[#3b82f6]/15 rounded-lg flex-shrink-0">
                    <i className={`${item.solutionIcon} text-[#3b82f6] text-xl`}></i>
                  </div>
                  <p className="text-gray-200 text-sm leading-relaxed pt-1">{item.solution}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom image strip */}
        <div className="relative rounded-2xl overflow-hidden h-56 md:h-72">
          <img
            src="https://public.readdy.ai/ai/img_res/dc1ed7265a47326857a4e675baa70ef7.jpg"
            alt="Automotive inventory system"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/90 via-[#0a1628]/50 to-transparent"></div>
          <div className="absolute inset-0 flex items-center px-10">
            <div className="max-w-lg">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
                One platform. Every workflow.
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                From the shop floor to the front desk — PRODIFY connects every part of your business in real time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
